// Some deps (e.g. @azure/event-hubs via rhea) read Buffer/process from the global
// scope at import time. vite-plugin-node-polyfills' globals-injection mode trips
// over its own shim files in dev (duplicate const declaration). Setting these by
// hand at the entry point avoids the plugin bug while still covering the deps.
import { Buffer } from 'buffer';
import process from 'process';

if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer;
}
if (typeof globalThis.process === 'undefined') {
  globalThis.process = process;
}
if (typeof globalThis.global === 'undefined') {
  globalThis.global = globalThis;
}
